import { useTranslation } from "react-i18next";
import _Slider from "react-slick";
import ApplicantItem from "../ApplicantItem/ApplicantItem";
import { ABOInfo, PartyInfo, ProfileInfo } from "../../../../services/Profile/profileAPI.types";
import defaultContent from "../../../../content/profile";
import "./ApplicantCarousel.scss";
import ProfileLoader from "../../ProfileLoader/ProfileLoader";
import LeafLinkButton from "../../../../common/leaf/LeafLinkButton/LeafLinkButton";
import { showApplicant } from "../../../../reducers/profile";
import { useAppDispatch } from "../../../../store";
import {
  cardActionClickTrack,
  viewAllApplicantsClickTrack,
} from "../../../../common/tealium/ABOProfile/Profile/ApplicantCardTrack";

// Vite 8 rolldown does not unwrap CJS __esModule default for react-slick
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Slider = ((_Slider as any).default ?? _Slider) as typeof _Slider;

type Props = {
  aboInfo?: ABOInfo;
  partyInfo?: PartyInfo[];
  isFetching: boolean;
  profileInfo: Partial<ProfileInfo>;
};

const ApplicantCarousel = (props: Props) => {
  const { t } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();

  const { aboInfo, partyInfo, isFetching, profileInfo } = props;
  const { privacyFlag } = aboInfo || {};
  const numberOfApplicant = partyInfo?.length || 0;

  const applicantTrackOnclick = (event?: string) => {
    cardActionClickTrack(event, false);
  };

  const viewAllApplicant = () => {
    dispatch(showApplicant());
    viewAllApplicantsClickTrack();
  };

  if (isFetching) {
    return <ProfileLoader row={1} applicant={true} isFetching={isFetching} />;
  }

  const sliderSetting = {
    dots: false,
    arrows: false,
    infinite: false,
    variableWidth: numberOfApplicant > 1,
    adaptiveHeight: true,
  };

  if (privacyFlag === true || numberOfApplicant === 0) return <></>;

  return (
    <div className="leaf-applicant-carousel">
      <div className="leaf-applicant-carousel__header">
        <h2 className="leaf-applicant-carousel__header__title">{`${t(
          "aboProfile.aboApplicants.title",
          defaultContent["aboProfile"]["aboApplicants"]["title"],
        )}`}</h2>
        <div className="leaf-applicant-carousel__header__view-all">
          <LeafLinkButton
            as="link"
            onClick={viewAllApplicant}
            label={`${t("aboProfile.aboApplicants.viewAll", defaultContent["aboProfile"]["aboApplicants"]["viewAll"])}`}
            fontSize={"medium"}
            fontWeight={"bold"}
          >
            {t("aboProfile.aboApplicants.viewAll", defaultContent["aboProfile"]["aboApplicants"]["viewAll"])}
          </LeafLinkButton>
        </div>
      </div>
      <div className="leaf-applicant-carousel__body">
        <Slider {...sliderSetting}>
          {partyInfo?.map((applicant, index) => {
            return (
              <div
                className="leaf-applicant-carousel__body__card"
                style={numberOfApplicant > 1 ? { width: 301 } : {}}
                key={index}
              >
                <ApplicantItem
                  aboInfo={aboInfo}
                  partyInfo={applicant}
                  isExpandable={false}
                  applicantTrackOnclick={applicantTrackOnclick}
                  profileInfo={profileInfo}
                />
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default ApplicantCarousel;
